import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppSelector } from "@redux/hooks";
import { selectStudentOnboarding } from "@user-management-context/write/application/use-cases/student-onboarding/selectors/student-onboarding-selectors";
import { StudentOnboarding } from "./student-onboarding.content";
import { useStudentOnboarding } from "./use-student-onboarding";
import { fullSchema, type StudentOnboardingFormInputs } from "./form-validation/full-form.schema";
import { defaultValues } from "./form-validation/shared";

export const StudentOnboardingContainer = () => {
  const { processing } = useAppSelector(selectStudentOnboarding);
  const form = useForm<StudentOnboardingFormInputs>({ resolver: yupResolver(fullSchema), defaultValues, mode: "onSubmit" });
  const { onboard } = useStudentOnboarding(form);

  return <StudentOnboarding form={form} onSubmit={form.handleSubmit(onboard)} submitting={processing === "pending"} />;
};
